export const GetAllStablishment = async (resource) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/stablishment`)
        .then(
            (response) => {
                result = response.body.stablishment
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}